import { withTheme } from '@material-ui/core';
import React, { useState } from 'react';
import { compose } from 'recompose';
import { withUserProfile } from '../../../userProfile/userProfileContext';
import { Resize, Popout } from '../../../layout/layoutHeader/components';
import MapDrawingToolBox from './../Settings/common/DrawTools/DrawingToolsBox';
import { withAppConfig } from '../../../appConfigContext';
import LocationToggler from './LocationToggler';
import appConstants from '../../../appConstants';
import { isLocationMappingEditable } from './MarkLocation/utils';
import WatchTutorial from '../../InAppTutorial/WatchTutorial';

const CustomerMapHeader = (props) => {
  const { classes, userData, ...other } = props;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  return (
    <>
      <LocationToggler
        eventHub={other.stack.layoutManager.eventHub}
        setIsDrawerOpen={setIsDrawerOpen}
        terminalId={props.userData.userProfile.terminal.id}
      />
      <MapDrawingToolBox
        hide={!isDrawerOpen}
        isCustomerMap={true}
        lasso
        mapId={appConstants.mapIds.CUSTOMER_MAP}
        useMapIdWithEvent
        disableDraw={!isLocationMappingEditable(userData.userProfile)}
      />
      <WatchTutorial componentId={appConstants.layout.CustomerMap} />
      <Resize {...other} isDefaultMaximize={isDrawerOpen} />
      <Popout {...other} />
    </>
  );
};

export default compose(withAppConfig, withUserProfile, withTheme())(CustomerMapHeader);
